<template>
	<div class="home" id="home" >
		<div class="list">
			<router-link to="/apropos">A propos</router-link>
			<router-link to="/contact">Contact</router-link>
		</div>
		<div class="list">
          <router-link to="/experiences">Experiences</router-link>
          <router-link to="/realisations">Réalisation</router-link>
          <router-link to="/competences">Compétences</router-link>
        </div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import HelloWorld from '@/components/HelloWorld.vue'

	export default {
		name: 'Home',
		components: {
			HelloWorld,
    },
      data:()=>({
      }),
      methods:{
      },


  }
</script>
<style>
  #home{
    height: calc(100vh - 90px);
    padding:0 100px;
    display: flex;
	  width: 100%;
    justify-content: space-between;
    align-items: center;
    transition: .3s;

  }
  .list{
    display: flex;
    flex-direction: column;
    width: 25%;
    height: 50%;
    justify-content: space-between;
  }
  .list a{
    text-transform: uppercase;
    font-size:1.3em;
    margin:20px;
    padding:20px 10px;
    border:1px solid white;
    transition:.3s;
  }
  .list a:hover{
    background:var(--background-hover);
    color:var(--color-hover);
    font-weight: bold;
  }
</style>
